import React from "react";
import { API_BASE_URL, apiRequest } from "../api/client";

const providerLabels: Record<string, string> = {
  google: "Continuar con Google",
  github: "Continuar con GitHub",
};

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="#4285F4"
        d="M23.49 12.27c0-.79-.07-1.55-.2-2.27H12v4.3h6.44a5.51 5.51 0 0 1-2.39 3.62v3h3.86c2.26-2.08 3.58-5.14 3.58-8.65z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.07 7.95-2.91l-3.86-3c-1.07.72-2.43 1.15-4.09 1.15-3.15 0-5.81-2.13-6.76-5H1.25v3.09A12 12 0 0 0 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M5.24 14.24a7.2 7.2 0 0 1 0-4.48V6.67H1.25a12 12 0 0 0 0 10.66l3.99-3.09z"
      />
      <path
        fill="#EA4335"
        d="M12 4.77c1.76 0 3.34.61 4.59 1.81l3.44-3.44C17.95 1.19 15.23 0 12 0A12 12 0 0 0 1.25 6.67l3.99 3.09c.95-2.87 3.61-4.99 6.76-4.99z"
      />
    </svg>
  );
}

function GithubIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 .5C5.65.5.5 5.73.5 12.18c0 5.16 3.29 9.54 7.85 11.08.57.11.78-.25.78-.56 0-.28-.01-1.02-.02-2-3.19.71-3.87-1.57-3.87-1.57-.52-1.35-1.27-1.7-1.27-1.7-1.04-.73.08-.72.08-.72 1.15.08 1.75 1.2 1.75 1.2 1.02 1.8 2.67 1.28 3.32.98.1-.75.4-1.28.73-1.57-2.55-.3-5.23-1.3-5.23-5.8 0-1.28.45-2.32 1.19-3.14-.12-.3-.52-1.52.11-3.17 0 0 .97-.32 3.19 1.2a10.8 10.8 0 0 1 5.8 0c2.21-1.52 3.18-1.2 3.18-1.2.64 1.65.24 2.87.12 3.17.74.82 1.19 1.86 1.19 3.14 0 4.51-2.69 5.49-5.25 5.79.41.36.78 1.08.78 2.18 0 1.57-.01 2.84-.01 3.23 0 .31.2.68.79.56a11.73 11.73 0 0 0 7.84-11.08C23.5 5.73 18.35.5 12 .5z"
      />
    </svg>
  );
}

function ProviderIcon({ provider }: { provider: string }) {
  if (provider === "google") return <GoogleIcon />;
  if (provider === "github") return <GithubIcon />;
  return null;
}

export function SocialLoginButtons() {
  const [providers, setProviders] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let isMounted = true;
    apiRequest<{ providers: string[] }>("/auth/providers")
      .then(response => {
        if (!isMounted) return;
        setProviders(response.providers);
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err instanceof Error ? err.message : "No se pudieron cargar las opciones de social login");
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="loader" style={{ alignSelf: "center" }}>
        <div className="spinner" />
        Conectando con proveedores...
      </div>
    );
  }

  if (error) {
    return (
      <div className="empty-state" style={{ borderColor: "rgba(220, 38, 38, 0.4)", color: "#b91c1c" }}>
        {error}
      </div>
    );
  }

  if (!providers.length) {
    return (
      <div className="empty-state">
        Activa Google en las variables de entorno para ofrecer inicio de sesión social.
      </div>
    );
  }

  const sortedProviders = [...providers].sort((a, b) => {
    if (a === "google") return -1;
    if (b === "google") return 1;
    return a.localeCompare(b);
  });

  return (
    <div className="form-grid">
      {sortedProviders.map(provider => (
        <button
          key={provider}
          type="button"
          className="btn btn-secondary"
          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}
          onClick={() => {
            window.location.href = `${API_BASE_URL}/auth/${provider}`;
          }}
        >
          <ProviderIcon provider={provider} />
          {providerLabels[provider] ?? `Continuar con ${provider}`}
        </button>
      ))}
    </div>
  );
}
